import { RouterType, LocalRouterType, IPropsRouter } from '../type';

interface IRouterMap {
    [index: string]: RouterType;
}

interface INotVerifyFlatMenus extends IPropsRouter {
    url: string;
}

const getFlatMenuRoutes = (menuData: LocalRouterType[]) => {
    let keys: any = {};
    menuData.forEach((item: LocalRouterType) => {
        item.path &&
            (keys[item.path] = {
            	component: item.component || null,
            	hidden: item.hidden,
            });
        if (item.child) {
            keys = { ...keys, ...getFlatMenuRoutes(item.child) };
            //   item.child = [];
        }
    });
    return keys;
};

let routerList: any = [];
let notVerifyFlatMenus: INotVerifyFlatMenus[] = [];
let showPathNotInRouters = false;
/**
 * get SubMenu or Item
 */
const getSubMenu = (item: RouterType): RouterType => {
    // doc: add hideChildrenInMenu
    if (routerList[item.url] || showPathNotInRouters) {
        item.component = routerList[item.url] ? routerList[item.url].component : undefined;
        item.hidden = !item.is_display;
    } else {
        item.notIsExist = true;
    }

    if (item.child_navigations && item.child_navigations.some((child: RouterType) => child.title)) {
        return {
            ...item,
            // eslint-disable-next-line no-use-before-define
            child: filterMenuData(item.child_navigations),
        };
    }
    return item;
};

/**
 * filter menuData
 */
const filterMenuData = (menuData: RouterType[]) => {
    if (!menuData) {
        return [];
    }
    return menuData
        .filter(item => item.title && !item.hidden)
        .map(item => getSubMenu(item))
        .filter(item => item);
};

const visibleMenu = (menuData: RouterType[]) => {
    if (!menuData) {
        return [];
    }
    return menuData
        .map(item => getSubMenu(item))
        .filter(item => item.title && !item.hidden && !item.notIsExist)
        .filter(item => item);
};

// 权限系统菜单列表中不存在本地设置不需校验权限菜单时，加入列表。在路由中注册
const dealNotVerifyMenus = (menus: IRouterMap): IRouterMap => {
    if (!notVerifyFlatMenus.length) {
        return menus;
    }
    const keys = Object.keys(menus);
    notVerifyFlatMenus.forEach(item => {
        const index = keys.findIndex(menu => menu === item.url);
        if (index === -1) {
            menus[item.url] = {
                ...item,
                title: item.name,
                child: undefined,
            };
        }
    });
    return menus;
};

/**
 * 获取面包屑映射
 * @param {Object} menuData 菜单配置
 */
export const getBreadcrumbNameMap = (menuData: RouterType[]) => {
    if (!menuData) {
        return {};
    }
    const routerMap: IRouterMap = {};

    const flattenMenuData = (data: RouterType[]) => {
        data.forEach((menuItem: RouterType) => {
            if (menuItem.child_navigations) {
                flattenMenuData(menuItem.child_navigations);
            }
            // Reduce memory usage
            routerMap[menuItem.url] = menuItem;
        });
    };
    flattenMenuData(menuData);
    return dealNotVerifyMenus(routerMap);
};

/**
 * 本地菜单不需要校验权限flat列表
 * @param list 本地菜单
 * return 展开后不需要校验权限菜单列表 [IPropsRouter]
 */
const dealNotVerifyMenu = (list: IPropsRouter[]) => {
    let notVerifyMenus: INotVerifyFlatMenus[] = [];
    list.forEach((item: IPropsRouter) => {
        if (item.notVerify) {
            notVerifyMenus.push({
                ...item,
                url: item.path,
                child: [],
            });
        }
        if (item.child && item.child.length) {
            notVerifyMenus = notVerifyMenus.concat(dealNotVerifyMenu(item.child));
        }
    });
    return notVerifyMenus;
};

export const getMenus = (originRouter: IPropsRouter[], routes: RouterType[], ignore = false) => {
    routerList = getFlatMenuRoutes(originRouter);
    notVerifyFlatMenus = dealNotVerifyMenu(originRouter);
    showPathNotInRouters = ignore;

    const menuData = filterMenuData(routes);
    const menuVisibleData = visibleMenu(routes);
    const breadcrumbNameMap = getBreadcrumbNameMap(routes);

    return {
        menuData,
        menuVisibleData,
        breadcrumbNameMap,
        flatOriginRouters: routerList,
        notVerifyFlatMenus,
    };
};
